import API from 'utils/API';
import http from 'utils/http';
import MemoryCache from 'utils/MemoryCache';

const cache = new MemoryCache();

class AgreementStore {
    getAgreement(id, isAgreement: boolean, legal_version?: string) {
        const cacheId = `${isAgreement ? 'agreement' : 'statement'}-${id}`;
        // agreement 预览模式下有该参数，必选参数
        const fromDraft = !!legal_version;

        if (!fromDraft && cache.has(cacheId)) {
            return Promise.resolve(cache.get(cacheId));
        }

        return http
            .get(API.CUSTOMER[isAgreement ? 'agreement' : 'statement'](id), {
                params: legal_version ? { legal_version } : {}
            })
            .then(resp => cache.set(cacheId, resp.data, 600));
    }
}

export default new AgreementStore();
